<template>
  <section class="zohoMea-section bg-dark-blue mb-5">
    <div class="map-pattern"></div>

    <div class="container">
      <div class="main-header">
        <h2 class="heading" data-aos="fade-up" data-aos-duration="2000">
          {{ $t("step_view_content['main_header']['Heading_One']") }}
          <span class="yellow">{{
            $t("step_view_content['main_header']['Heading_Yellow']")
          }}</span>
          {{ $t("step_view_content['main_header']['Heading_Third']") }}
        </h2>
      </div>

      <div class="row justify-content-between">
        <div class="col-lg-6">
          <img loading="lazy" :src="'https://measiteassetpublic.zohostratus.in/img/left-img.svg'"
            alt=""
            class="imge-card"
            data-aos="fade-up"
            data-aos-delay="300"
          />
        </div>
        <div class="col-lg-6 mb-4">
          <ul class="steps-list">
            <li class="step-content">
              <div class="infos">
                <h3 data-aos="fade-up" data-aos-delay="0">
                  {{ $t("step_view_content['step_content'][0]['title']") }}
                </h3>
                <p data-aos="fade-up">
                  {{ $t("step_view_content['step_content'][0]['content']") }}
                </p>
              </div>
              <div class="step-icon">
                <img loading="lazy" :src="'https://measiteassetpublic.zohostratus.in/img/icon1.svg'" alt="" />
              </div>
            </li>
            <li class="step-content">
              <div class="infos">
                <h3 data-aos="fade-up" data-aos-delay="100">
                  {{ $t("step_view_content['step_content'][1]['title']") }}
                </h3>
                <p data-aos="fade-up">
                  {{ $t("step_view_content['step_content'][1]['content']") }}
                </p>
              </div>
              <div class="step-icon">
                <img loading="lazy" :src="'https://measiteassetpublic.zohostratus.in/img/icon2.svg'" alt="" />
              </div>
            </li>
            <li class="step-content">
              <div class="infos">
                <h3 data-aos="fade-up" data-aos-delay="200">
                  {{ $t("step_view_content['step_content'][2]['title']") }}
                </h3>
                <p data-aos="fade-up">
                  {{ $t("step_view_content['step_content'][2]['content']") }}
                </p>
              </div>
              <div class="step-icon">
                <img loading="lazy" :src="'https://measiteassetpublic.zohostratus.in/img/icon3.svg'" alt="" />
              </div>
            </li>
            <li>
              <div class="step-content">
                <div class="infos">
                  <h3 data-aos="fade-up" data-aos-delay="300">
                    {{ $t("step_view_content['step_content'][3]['title']") }}
                  </h3>
                  <p data-aos="fade-up" data-aos-delay="200">
                    {{ $t("step_view_content['step_content'][3]['content']") }}
                  </p>
                </div>
                <div class="step-icon">
                  <img loading="lazy" :src="'https://measiteassetpublic.zohostratus.in/img/icon4.svg'" alt="" />
                </div>
              </div>
            </li>
            <li>
              <div class="step-content">
                <div class="infos">
                  <h3 data-aos="fade-up" data-aos-delay="400">
                    {{ $t("step_view_content['step_content'][4]['title']") }}
                  </h3>
                  <p data-aos="fade-up" data-aos-delay="300">
                    {{ $t("step_view_content['step_content'][4]['content']") }}
                  </p>
                </div>
                <div class="step-icon white">
                  <img loading="lazy" :src="'https://measiteassetpublic.zohostratus.in/img/icon5.svg'" alt="" />
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "HomeStepsVue",
};
</script>

<style>
</style>